"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteServiceClient = void 0;
const common_types_1 = require("@cfc/common-types");
const GetRoute_1 = require("./commands/GetRoute");
const BuildTrees_1 = require("./commands/BuildTrees");
const GetSubNav_1 = require("./commands/GetSubNav");
class RouteServiceClient {
    constructor(config) {
        this.config = config;
        if (!config.environment && !config.customEndpoint) {
            throw new Error("RouteServiceClientConfig must have either contain an environment or a customEndpoint");
        }
    }
    getEndpoint() {
        if (this.config.customEndpoint) {
            return this.config.customEndpoint;
        }
        switch (this.config.environment) {
            case common_types_1.CfcEnvironment.PROD:
                return "https://route.secondstep.org";
            default:
                return `https://route-${this.config.environment}.cfctest.org`;
        }
    }
    getRoute(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const command = new GetRoute_1.GetRouteCommand(this.getEndpoint(), input);
            return yield command.execute();
        });
    }
    buildTrees(input) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.config.apiKey) {
                throw new Error("API key is required to build trees");
            }
            const command = new BuildTrees_1.BuildTreesCommand(this.getEndpoint(), this.config.apiKey, input);
            yield command.execute();
        });
    }
    getSubNav(input) {
        return __awaiter(this, void 0, void 0, function* () {
            const command = new GetSubNav_1.GetSubNavCommand(this.getEndpoint(), input);
            return yield command.execute();
        });
    }
}
exports.RouteServiceClient = RouteServiceClient;
